"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateGalleryListItemResponseFieldToJSON = exports.TemplateGalleryListItemResponseFieldToJSONJoined = exports.TemplateGalleryListItemResponseFieldFromJSONTyped = exports.TemplateGalleryListItemResponseFieldFromJSON = exports.instanceOfTemplateGalleryListItemResponseField = exports.TemplateGalleryListItemResponseFieldTypeEnum = exports.attributeTypeMapTemplateGalleryListItemResponseField = void 0;
var TemplateGalleryListItemResponseFieldCheckbox_1 = require("./TemplateGalleryListItemResponseFieldCheckbox");
var TemplateGalleryListItemResponseFieldDate_1 = require("./TemplateGalleryListItemResponseFieldDate");
var TemplateGalleryListItemResponseFieldDropdown_1 = require("./TemplateGalleryListItemResponseFieldDropdown");
var TemplateGalleryListItemResponseFieldHyperlink_1 = require("./TemplateGalleryListItemResponseFieldHyperlink");
var TemplateGalleryListItemResponseFieldImage_1 = require("./TemplateGalleryListItemResponseFieldImage");
var TemplateGalleryListItemResponseFieldInitials_1 = require("./TemplateGalleryListItemResponseFieldInitials");
var TemplateGalleryListItemResponseFieldRadio_1 = require("./TemplateGalleryListItemResponseFieldRadio");
var TemplateGalleryListItemResponseFieldRectangle_1 = require("./TemplateGalleryListItemResponseFieldRectangle");
var TemplateGalleryListItemResponseFieldSignature_1 = require("./TemplateGalleryListItemResponseFieldSignature");
var TemplateGalleryListItemResponseFieldText_1 = require("./TemplateGalleryListItemResponseFieldText");
exports.attributeTypeMapTemplateGalleryListItemResponseField = [
    {
        name: "id",
        type: "string",
    },
    {
        name: "type",
        type: "string",
    },
    {
        name: "pageIndex",
        type: "number",
    },
    {
        name: "x",
        type: "number",
    },
    {
        name: "y",
        type: "number",
    },
    {
        name: "signer",
        type: "string",
    },
    {
        name: "width",
        type: "number",
    },
    {
        name: "height",
        type: "number",
    },
    {
        name: "documentId",
        type: "string",
    },
];
/**
 * @export
 */
exports.TemplateGalleryListItemResponseFieldTypeEnum = {
    Checkbox: "checkbox",
    Date: "date",
    Dropdown: "dropdown",
    Image: "image",
    Initials: "initials",
    Radiobutton: "radiobutton",
    Rectangle: "rectangle",
    Signature: "signature",
    Text: "text",
    Hyperlink: "hyperlink",
};
/**
 * Check if a given object implements the TemplateGalleryListItemResponseField interface.
 */
function instanceOfTemplateGalleryListItemResponseField(value) {
    if (!("id" in value) || value["id"] === undefined)
        return false;
    if (!("type" in value) || value["type"] === undefined)
        return false;
    if (!("pageIndex" in value) || value["pageIndex"] === undefined)
        return false;
    if (!("x" in value) || value["x"] === undefined)
        return false;
    if (!("y" in value) || value["y"] === undefined)
        return false;
    if (!("signer" in value) || value["signer"] === undefined)
        return false;
    if (!("width" in value) || value["width"] === undefined)
        return false;
    if (!("height" in value) || value["height"] === undefined)
        return false;
    if (!("documentId" in value) || value["documentId"] === undefined)
        return false;
    return true;
}
exports.instanceOfTemplateGalleryListItemResponseField = instanceOfTemplateGalleryListItemResponseField;
function TemplateGalleryListItemResponseFieldFromJSON(json) {
    return TemplateGalleryListItemResponseFieldFromJSONTyped(json, false);
}
exports.TemplateGalleryListItemResponseFieldFromJSON = TemplateGalleryListItemResponseFieldFromJSON;
function TemplateGalleryListItemResponseFieldFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json["type"] === "checkbox") {
            return (0, TemplateGalleryListItemResponseFieldCheckbox_1.TemplateGalleryListItemResponseFieldCheckboxFromJSONTyped)(json, true);
        }
        if (json["type"] === "date") {
            return (0, TemplateGalleryListItemResponseFieldDate_1.TemplateGalleryListItemResponseFieldDateFromJSONTyped)(json, true);
        }
        if (json["type"] === "dropdown") {
            return (0, TemplateGalleryListItemResponseFieldDropdown_1.TemplateGalleryListItemResponseFieldDropdownFromJSONTyped)(json, true);
        }
        if (json["type"] === "hyperlink") {
            return (0, TemplateGalleryListItemResponseFieldHyperlink_1.TemplateGalleryListItemResponseFieldHyperlinkFromJSONTyped)(json, true);
        }
        if (json["type"] === "image") {
            return (0, TemplateGalleryListItemResponseFieldImage_1.TemplateGalleryListItemResponseFieldImageFromJSONTyped)(json, true);
        }
        if (json["type"] === "initials") {
            return (0, TemplateGalleryListItemResponseFieldInitials_1.TemplateGalleryListItemResponseFieldInitialsFromJSONTyped)(json, true);
        }
        if (json["type"] === "radiobutton") {
            return (0, TemplateGalleryListItemResponseFieldRadio_1.TemplateGalleryListItemResponseFieldRadioFromJSONTyped)(json, true);
        }
        if (json["type"] === "rectangle") {
            return (0, TemplateGalleryListItemResponseFieldRectangle_1.TemplateGalleryListItemResponseFieldRectangleFromJSONTyped)(json, true);
        }
        if (json["type"] === "signature") {
            return (0, TemplateGalleryListItemResponseFieldSignature_1.TemplateGalleryListItemResponseFieldSignatureFromJSONTyped)(json, true);
        }
        if (json["type"] === "text") {
            return (0, TemplateGalleryListItemResponseFieldText_1.TemplateGalleryListItemResponseFieldTextFromJSONTyped)(json, true);
        }
    }
    return {
        id: json["id"],
        type: json["type"],
        pageIndex: json["pageIndex"],
        x: json["x"],
        y: json["y"],
        signer: json["signer"],
        width: json["width"],
        height: json["height"],
        documentId: json["documentId"],
    };
}
exports.TemplateGalleryListItemResponseFieldFromJSONTyped = TemplateGalleryListItemResponseFieldFromJSONTyped;
function TemplateGalleryListItemResponseFieldToJSONJoined(value) {
    if (value == null) {
        return value;
    }
    if (value["type"] === "checkbox") {
        return (0, TemplateGalleryListItemResponseFieldCheckbox_1.TemplateGalleryListItemResponseFieldCheckboxToJSON)(value);
    }
    if (value["type"] === "date") {
        return (0, TemplateGalleryListItemResponseFieldDate_1.TemplateGalleryListItemResponseFieldDateToJSON)(value);
    }
    if (value["type"] === "dropdown") {
        return (0, TemplateGalleryListItemResponseFieldDropdown_1.TemplateGalleryListItemResponseFieldDropdownToJSON)(value);
    }
    if (value["type"] === "hyperlink") {
        return (0, TemplateGalleryListItemResponseFieldHyperlink_1.TemplateGalleryListItemResponseFieldHyperlinkToJSON)(value);
    }
    if (value["type"] === "image") {
        return (0, TemplateGalleryListItemResponseFieldImage_1.TemplateGalleryListItemResponseFieldImageToJSON)(value);
    }
    if (value["type"] === "initials") {
        return (0, TemplateGalleryListItemResponseFieldInitials_1.TemplateGalleryListItemResponseFieldInitialsToJSON)(value);
    }
    if (value["type"] === "radiobutton") {
        return (0, TemplateGalleryListItemResponseFieldRadio_1.TemplateGalleryListItemResponseFieldRadioToJSON)(value);
    }
    if (value["type"] === "rectangle") {
        return (0, TemplateGalleryListItemResponseFieldRectangle_1.TemplateGalleryListItemResponseFieldRectangleToJSON)(value);
    }
    if (value["type"] === "signature") {
        return (0, TemplateGalleryListItemResponseFieldSignature_1.TemplateGalleryListItemResponseFieldSignatureToJSON)(value);
    }
    if (value["type"] === "text") {
        return (0, TemplateGalleryListItemResponseFieldText_1.TemplateGalleryListItemResponseFieldTextToJSON)(value);
    }
}
exports.TemplateGalleryListItemResponseFieldToJSONJoined = TemplateGalleryListItemResponseFieldToJSONJoined;
function TemplateGalleryListItemResponseFieldToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value["id"],
        type: value["type"],
        pageIndex: value["pageIndex"],
        x: value["x"],
        y: value["y"],
        signer: value["signer"],
        width: value["width"],
        height: value["height"],
        documentId: value["documentId"],
    };
}
exports.TemplateGalleryListItemResponseFieldToJSON = TemplateGalleryListItemResponseFieldToJSON;
